import tencent from "../tencent";

export default tencent;
